export default "__VITE_ASSET__PJaTlik2__"